/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.12.0
 * @since 1.12.0
 */

import { useCallback } from 'react';

import { useDispatch } from 'react-redux';

import { sendTableFieldsSize } from '../actions/tableActions';
import { IFieldResize, TableNameType } from '../types/tableTypes';

export const useTableResize = (tableName: TableNameType) => {
    const dispatch = useDispatch();

    return useCallback((fields: IFieldResize[]) => {
        dispatch(sendTableFieldsSize({
            fields: fields.map((field: IFieldResize) => ({ name: field.id, size: field.value })),
            tableName,
        }));
    }, [tableName, dispatch]);
};
